import React, { useState, useMemo } from 'react';
import { useScrollAnimation } from './hooks/ScrollAnimation';
import { rawCertificatesData } from '../data/certificatesData';
import { useTheme } from '../context/ThemeContext';
import GlobalGameJam from '../assets/Certificates/globalgamejam.png';
import DataScient from '../assets/Certificates/DataScientDicoding.png';
import EndlessGame from '../assets/Certificates/endlessgame.png';
import IGDX from '../assets/Certificates/igdx2024.png';
import JavaDicoding from '../assets/Certificates/JavaDicoding.png';
import SQLDicoding from '../assets/Certificates/SqlDicoding.png';
import VisualData from '../assets/Certificates/visualdata.png';
import VueJSWantek from '../assets/Certificates/VueJSWantek.png';
import BackendCyber from '../assets/Certificates/backendCyberlabs.png';
import UnityCertificated from '../assets/Certificates/UnityCertificated.png';
import Mandarin from '../assets/Certificates/mandarin2025.png';
import CodeLamp_GameDev from '../assets/Certificates/codelamp_gdev.png';
import CodeLamp_obsecure from '../assets/Certificates/codelamp_obsecure.png';
import Ibik1 from '../assets/Certificates/ibik1.png'
import ibm1 from '../assets/Certificates/IBM1.png'
import ibm2 from '../assets/Certificates/IBM2.png'
import ibm3 from '../assets/Certificates/IBM3.png'

const CertificateCard = ({ cert, index, onOpen, isDark }) => {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.1 });
  const delay = (index % 2) * 100;

  const cardBg = isDark ? 'bg-[#0D1520]' : 'bg-white';
  const thumbBg = isDark ? 'bg-[#111C2C]' : 'bg-gray-200';
  const titleColor = isDark ? 'text-slate-100' : 'text-gray-800';
  const badgeBg = isDark ? 'bg-blue-900 text-blue-300' : 'bg-blue-100 text-blue-800';
  const issuerColor = isDark ? 'text-slate-400' : 'text-gray-600';
  const btnBg = isDark ? 'bg-[#111C2C] text-slate-200 hover:bg-blue-900' : 'bg-gray-800 text-white hover:bg-gray-900';

  return (
    <div
      ref={ref}
      className={`${cardBg} p-3 md:p-4 pixel-border flex flex-col h-full`}
      style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(32px)',
        transition: `opacity 0.6s ease-out ${delay}ms, transform 0.6s ease-out ${delay}ms`,
      }}
    >
      <div
        className={`h-32 md:h-40 ${thumbBg} mb-3 md:mb-4 overflow-hidden pixel-border cursor-pointer flex-shrink-0`}
        onClick={() => onOpen(cert)}
      >
        <img
          src={cert.image}
          alt={cert.title}
          className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
        />
      </div>

      <div className="flex justify-between items-start mb-2 md:mb-3 gap-2">
        <h3 className={`text-md md:text-lg font-bold ${titleColor} leading-tight`}>{cert.title}</h3>
        <span className={`${badgeBg} px-2 py-1 text-[10px] md:text-xs pixel-border whitespace-nowrap`}>
          {cert.date}
        </span>
      </div>

      <p className={`${issuerColor} mb-4 text-sm`}>{cert.issuer}</p>

      <button
        className={`w-full mt-auto pixel-button ${btnBg} py-2 text-xs transition-colors`}
        onClick={() => onOpen(cert)}
      >
        LIHAT SERTIFIKAT
      </button>
    </div>
  );
};

const Certificates = () => {
  const { isDark } = useTheme();
  const [selectedCertificate, setSelectedCertificate] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [visibleCount, setVisibleCount] = useState(4);
  const [showAll, setShowAll] = useState(false);

  const { ref: titleRef,      isVisible: titleVisible      } = useScrollAnimation({ threshold: 0.1 });
  const { ref: paginationRef, isVisible: paginationVisible } = useScrollAnimation({ threshold: 0.1 });

  const certificateImages = [JavaDicoding, DataScient, SQLDicoding, EndlessGame, VueJSWantek, BackendCyber, IGDX, VisualData, GlobalGameJam, UnityCertificated, Mandarin, CodeLamp_GameDev, CodeLamp_obsecure, Ibik1, ibm1, ibm2, ibm3];

  const rawCertificates = rawCertificatesData.map((cert, i) => ({
    ...cert,
    image: certificateImages[i],
  }));

  const sortedCertificates = useMemo(() => {
    return [...rawCertificates].sort((a, b) => b.id - a.id);
  }, []);

  const loadMore = () => {
    setVisibleCount(sortedCertificates.length);
    setShowAll(true);
  };

  const showLess = () => {
    setVisibleCount(4);
    setShowAll(false);
  };

  const openModal = (cert) => {
    setSelectedCertificate(cert);
    setIsModalOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedCertificate(null);
    document.body.style.overflow = 'unset';
  };

  const sectionBg = isDark ? 'bg-[#0D1520]' : 'bg-gray-50';
  const titleColor = isDark ? 'text-white' : 'text-gray-800';
  const subtitleColor = isDark ? 'text-slate-400' : 'text-gray-600';
  const modalBg = isDark ? 'bg-[#0D1520]' : 'bg-white';
  const modalTitleColor = isDark ? 'text-slate-100' : 'text-gray-800';
  const modalSubColor = isDark ? 'text-slate-400' : 'text-gray-600';
  const modalImgBg = isDark ? 'bg-[#111C2C]' : 'bg-gray-100';
  const modalBtnBg = isDark ? 'bg-[#111C2C] text-slate-200 hover:bg-blue-900' : 'bg-gray-800 text-white hover:bg-gray-900';

  return (
    <section id="certificates" className="py-8 md:py-12 px-4 pixel-grid">
      <div className="container mx-auto max-w-5xl">

        {/* Judul */}
        <div
          ref={titleRef}
          style={{
            opacity: titleVisible ? 1 : 0,
            transform: titleVisible ? 'translateY(0)' : 'translateY(-24px)',
            transition: 'opacity 0.6s ease-out, transform 0.6s ease-out',
          }}
        >
          <h2 className={`text-xl md:text-2xl lg:text-3xl font-bold text-center ${titleColor} mb-2 pixel-font`}>
            <span className="glitch-text" data-text="SERTIFIKAT">SERTIFIKAT</span>
          </h2>
          <p className={`text-center ${subtitleColor} mb-8 md:mb-12 text-sm md:text-base`}>
            Pencapaian dan berbagai Sertifikat Saya ({sortedCertificates.length})
          </p>
        </div>

        {/* Grid Kartu */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
          {sortedCertificates.slice(0, visibleCount).map((cert, index) => (
            <CertificateCard
              key={cert.id}
              cert={cert}
              index={index}
              onOpen={openModal}
              isDark={isDark}
            />
          ))}
        </div>

        {/* Tombol Load More / Show Less */}
        {sortedCertificates.length > 4 && (
          <div
            ref={paginationRef}
            className="text-center mt-12"
            style={{
              opacity: paginationVisible ? 1 : 0,
              transform: paginationVisible ? 'translateY(0)' : 'translateY(16px)',
              transition: 'opacity 0.5s ease-out 0.1s, transform 0.5s ease-out 0.1s',
            }}
          >
            {!showAll ? (
              <button
                className={`pixel-button py-2 px-6 ${isDark ? 'bg-[#111C2C] text-slate-200 hover:bg-blue-900' : 'bg-gray-800 text-white hover:bg-gray-900'}`}
                onClick={loadMore}
              >
                LOAD MORE ({sortedCertificates.length - visibleCount} MORE)
              </button>
            ) : (
              <button
                className={`pixel-button py-2 px-6 ${isDark ? 'bg-[#1E3A5F] text-slate-300 hover:bg-blue-900' : 'bg-gray-600 text-white hover:bg-gray-700'}`}
                onClick={showLess}
              >
                SHOW LESS
              </button>
            )}
          </div>
        )}

        {/* Modal Sertifikat */}
        {isModalOpen && selectedCertificate && (
          <div
            className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-[999] p-4"
            onClick={closeModal}
          >
            <div
              className={`relative max-w-4xl w-full ${modalBg} p-4 md:p-6 pixel-border`}
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="absolute -top-12 right-0 text-white text-4xl hover:text-gray-300 transition-colors"
                onClick={closeModal}
              >
                &times;
              </button>

              <div className="mb-4">
                <h3 className={`text-xl md:text-2xl font-bold ${modalTitleColor}`}>{selectedCertificate.title}</h3>
                <p className={modalSubColor}>{selectedCertificate.issuer} - {selectedCertificate.date}</p>
              </div>

              <div className={`${modalImgBg} pixel-border overflow-hidden`}>
                <img
                  src={selectedCertificate.image}
                  alt={selectedCertificate.title}
                  className="w-full h-auto max-h-[70vh] object-contain mx-auto"
                />
              </div>

              <div className="mt-6 flex justify-end">
                <button
                  className={`pixel-button ${modalBtnBg} py-2 px-8 text-sm`}
                  onClick={closeModal}
                >
                  TUTUP
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Certificates;
